<template>
    <CardShell>

        <mq-layout mq="sm+">
            <BackLinkHeading :linkText="listing.title" text="Request Rental" :route="'/listing-detail/' + listing.listingId" :sizeDependent="false"/>
        </mq-layout>
        

        <!-- date selection -->
        <div class="ph3 ph4-ns">
            <h6 class="pt4 mb3">The requested rental period is.</h6>
            <DatesSelection class="mb4" :startDate="startDate" :endDate="endDate" @startDateChanged="updateStartDate" @endDateChanged="updateEndDate" />
            
            <!-- handoff -->
            <HandoffDetails/>
        </div>
    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import BackLinkHeading from '@/components/controls/BackLinkHeading.vue';
import DatesSelection from '@/components/global/DatesSelection.vue';
import HandoffDetails from '@/components/rent/rentalDetails/HandoffDetails.vue';
import { mapState, mapMutations } from 'vuex';

export default {
    components: {
        CardShell,
        DatesSelection,
        HandoffDetails,
        BackLinkHeading
    },
    props: {
        listing: {
            type: Object
        }
    },
    computed: {
        ...mapState('newRental', ['userInput']),
        startDate() {
            return this.userInput.startDate;
        },
        endDate() {
            return this.userInput.endDate;
        }
    },
    methods: {
        ...mapMutations('newRental', ['updateStartDate', 'updateEndDate'])
    }
};
</script>
